import axiosClient from "../../../../../../api/axiosClient";

const lookupService = {

    searchCustomers: async (keyword = "") => {

    try {

      const response = await axiosClient.get(
        "/api/ppe/material-flow/purchase-order/customers/search",
        {
          params: { q: keyword }
        }
      );

      return response.data.data || [];

    } catch (error) {

      return [];

    }

  },
  
  
  // -----------------------------------------
  // Vendor Search
  // -----------------------------------------
  searchVendors: async (keyword = "") => {
  try {
    const response = await axiosClient.get(
      "/api/ppe/material-flow/purchase-order/vendors/search",
      {
        params: { q: keyword },
      }
    );

    return response.data.data || [];
  } catch (error) {
    return [];
  }
},

  // Placeholders for next steps
  searchMaterials: async (keyword = "") => {
  try {
    const response = await axiosClient.get(
      "/api/ppe/material-flow/purchase-order/materials/search",
      {
        params: { q: keyword },
      }
    );

    return response.data.data || [];
  } catch (error) {
    return [];
  }
},


  searchPR: async (keyword = "") => [],
  searchIndents: async (keyword = "") => [],
  searchRFQ: async (keyword = "") => [],

  getTermsConditions: async () => {
    try {

      const response = await axiosClient.get(
        "/api/ppe/material-flow/purchase-order/terms-conditions"
      );

      return response.data.data || [];

    } catch (error) {

      return [];
    }
  },


};

export default lookupService;
